import React from 'react';
import T from 'prop-types';
var FormSection = function(props) {
    var children = props.children, title = props.title;
    return /*#__PURE__*/ React.createElement("div", {
        className: "FormSection"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "title"
    }, title), children);
};
FormSection.propTypes = {
    children: T.node,
    title: T.string
};
export default FormSection;
